import { Component, input, model, output } from '@angular/core';
import { ArtButtonComponent } from '../art-button/art-button.component';
import { DesignSystemModule } from '@compeople-shared/design-system-angular';
import { DragAndDropComponent } from '../drag-and-drop/drag-and-drop.component';
import { provideTranslocoScope, TranslocoPipe } from '@jsverse/transloco';
import { ImageUploadResult } from '@utils/interfaces';
import { BorderedImageComponent } from '../bordered-image/bordered-image.component';

@Component({
  selector: 'art-image-switch-area',
  templateUrl: './image-switch-area.component.html',
  styleUrl: './image-switch-area.component.scss',
  imports: [ArtButtonComponent, DesignSystemModule, DragAndDropComponent, TranslocoPipe, BorderedImageComponent],
  providers: [provideTranslocoScope('dropzone')],
})
export class ImageSwitchAreaComponent {
  altText = input<string | null>(null);
  imageUrl = input<string | null>(null);
  imageError = input<boolean>(false);
  errorMessage = input<string>('');
  showDragAndDrop = model<boolean>(false);
  uploadedImage = output<ImageUploadResult>();

  showImageUpload() {
    this.showDragAndDrop.set(true);
  }

  cancelImageUpload() {
    this.showDragAndDrop.set(false);
  }

  uploadImage(event: ImageUploadResult) {
    this.uploadedImage.emit(event);
  }
}
